import AppEvents from './lib/AppEvents';
import AppLogs from './lib/AppLogs';
import AppModule from './lib/AppModule';
import IAppLogger from './lib/IAppLogger';
import IAppManager from './lib/IAppManager';

export class AppManager implements IAppManager {
  private _logs: AppLogs = new AppLogs(this);
  private _events: AppEvents = new AppEvents(this);
  private _started = false;
  private _modules: AppModule[] = [];

  public start(modules: AppModule[]) {
    if (this._started) {
      return;
    }
    this._started = true;
    this._modules = modules;
    this._events.enable();

    this.registerEvents();
    this.preloadModules();
    this.loadModules();

    this._events.emit('app.started');
  }

  public get events() {
    return this._events;
  }

  public logger(key: string): IAppLogger {
    return this._logs.get(key);
  }

  public get logs() {
    return this._logs;
  }

  // only events that are pre-registered can be emitted
  // add our app events and module events
  private registerEvents() {
    this.ensureStarted();
    this._events.registerEvent('app.started');
    this._modules.forEach((module) =>
      module.events.forEach((event) => this._events.registerEvent(event)),
    );
  }

  // we run through each module and call the preload() method to
  // allow a module to setup listeners before the app starts
  // and other modules load
  private preloadModules() {
    this.ensureStarted();
    this._modules.forEach((module) => module.preload());
  }

  // finally run through modules and call the load() method
  private loadModules() {
    this.ensureStarted();
    this._modules.forEach((module) => module.load());
  }

  private ensureStarted() {
    if (!this._started) {
      throw new Error('AppManager not started');
    }
  }
}

export default new AppManager();
